import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'cliente',
  type: 'node--client',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    title: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'title',
    },
    dni: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'dni',
    },
    nombre: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'nombre',
    },
    apellidos: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'apellidos',
    },
    cargo: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'cargo',
    },
    cp: {
      type: 'integer',
      required: false,
      isArray: false,
      name: 'codigo_pos',
    },
    comentario: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'comentario',
    },
    compania: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'compania',
    },
    deudor: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'deudor',
    },
    direccion: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'direccion',
    },
    email: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'e_mail',
    },
    hipotecante: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'hipotecante',
    },
    poblacion: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'poblacion',
    },
    provincia: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'provincia',
    },
    rating: {
      type: 'integer',
      required: false,
      isArray: false,
      name: 'rating',
    },
    tel1: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'tlfno_1',
    },
    tel2: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'tlfno_2',
    },
  },
  relationships: {
    estadoCivil: {
      type: 'taxonomy_term--civil_state',
      required: false,
      isArray: false,
      name: 'civil_state',
    },
    contacto: {
      type: 'node--contacto',
      required: false,
      isArray: false,
      name: 'contacto',
    },
    tipo: {
      type: 'taxonomy_term--person',
      required: false,
      isArray: false,
      name: 'person',
    },
    reputations: {
      type: 'node--online_reputation',
      required: false,
      isArray: true,
      name: 'reputations',
    },
  },
};

export const ClientService = createService(base, configuration, API_CONFIG.API);
export const ClientModule = createModule(ClientService, true);



// WEBPACK FOOTER //
// ./src/models/client.js